<template>
  <a-drawer width="35%" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('处理咨询预约单') }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('联系人')">
        <span>{{ current.contactName }}（{{ current.contactPhone }}）</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('目标状态')" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="20">{{ $t('已联系') }}</a-radio>
          <a-radio :value="30">{{ $t('已完成') }}</a-radio>
          <a-radio :value="40">{{ $t('已取消') }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('处理备注')" prop="handleRemark">
        <a-input v-model="form.handleRemark" :maxLength="500" :placeholder="$t('请输入')+$t('处理备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { handleEduConsult } from '@/api/edu/consult'

export default {
  name: 'HandleForm',
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      visible: false,
      current: {},
      form: {
        id: null,
        status: 20,
        handleRemark: null
      },
      rules: {
        status: [{ required: true, message: '请选择目标状态', trigger: 'change' }]
      }
    }
  },
  methods: {
    open (record) {
      this.current = record
      this.form = {
        id: record.id,
        status: 20,
        handleRemark: null
      }
      this.visible = true
    },
    onClose () {
      this.visible = false
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          handleEduConsult(this.form).then(response => {
            this.$message.success(this.$t('处理成功'), 3)
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
